module.exports = __webpack_public_path__ + "img/4.8f12e3b8.svg";